import { fetchBrary } from '../utils/FetchBrary';
import { addNotificationToApp, NotificationType } from './NotificationsActions';
import * as Api from '../apiCalls/enrollmentPackages/enrollmentPackageApiCalls';
import { ReduxDispatch } from '../types/redux/ReduxDispatch';
import { EnrollmentPackageId } from '../types/api/primaryKeys/PrimaryKey';
import { Package } from '../types/api/enrollmentPackages/Package';
import { SignatureDataModel } from '../types/api/enrollmentPackages/SignatureDataModel';
import { EnrollmentAssistant } from '../types/api/enrollmentPackages/EnrollmentAssistant';

const ROOT_URL = process.env.REACT_APP_API_URL;

export enum PackageActionType {
    FETCH_PACKAGE_INFO = 'FETCH_PACKAGE_INFO',
    FETCH_PACKAGE_INFO_SUCCESS = 'FETCH_PACKAGE_INFO_SUCCESS',
    FETCH_PACKAGE_INFO_FAILURE = 'FETCH_PACKAGE_INFO_FAILURE'
}

export type PackageAction =
    | ReturnType<typeof requestFetchPackageInfo>
    | ReturnType<typeof requestFetchPackageInfoSuccess>
    | ReturnType<typeof requestFetchPackageInfoFailure>;

function requestFetchPackageInfo() {
    return {
        type: PackageActionType.FETCH_PACKAGE_INFO
    } as const;
}

function requestFetchPackageInfoSuccess(packageInfo: Package) {
    return {
        type: PackageActionType.FETCH_PACKAGE_INFO_SUCCESS,
        payload: packageInfo
    } as const;
}

function requestFetchPackageInfoFailure(error: unknown) {
    return {
        type: PackageActionType.FETCH_PACKAGE_INFO_FAILURE,
        payload: error
    } as const;
}

export function fetchPackageInfo(packageId: EnrollmentPackageId) {
    return async (dispatch: ReduxDispatch) => {
        dispatch(requestFetchPackageInfo());

        try {
            const json = await Api.getCurrentPackageInfoAndSteps(packageId);
            dispatch(requestFetchPackageInfoSuccess(json));
            return json;
        }
        catch (err) {
            dispatch(requestFetchPackageInfoFailure(err));
            dispatch(addNotificationToApp("Failed To Get Package Details", NotificationType.Error));
        }
    };
}

export function fetchPostSignaturePackage(packageId: EnrollmentPackageId, signatureData: SignatureDataModel) {
    return async (dispatch: ReduxDispatch) => {
        try {
            await Api.addSignatureToPackage(packageId, signatureData);
            dispatch(addNotificationToApp("Successfully Signed Enrollment Package", NotificationType.Success));
        }
        catch {
            dispatch(addNotificationToApp("Failed To Sign Enrollment Package", NotificationType.Error));
        }
    };
}

export function updatePackageEnrollmentAssistantData(packageId: EnrollmentPackageId, enrollmentAssistant: EnrollmentAssistant) {
    return async (dispatch: ReduxDispatch) => {
        try {
            await Api.updatePackageEnrollmentAssistantData(packageId, enrollmentAssistant);
            dispatch(addNotificationToApp("Successfully Added Enrollment Assistant ID", NotificationType.Success));
        }
        catch {
            dispatch(addNotificationToApp("Failed To Add Enrollment Assistant To Package", NotificationType.Error));
        }
    };
}